import React from 'react'
import { Button } from 'react-bootstrap'
import { Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

export const VaccineList = ({ }) => {
  const dispatch = useDispatch()
  const { action } = useSelector(state => state.ui)
  const vaccines = useSelector(state=>state.vaccines)
  
  const newVaccine = () => dispatch({ type: "NEW_VACCINE" })
  const showEditVaccineModal = (resource) => {
    dispatch({
      type: "EDIT_RESOURCE",
      payload: {
        resourceName: "vaccine",
        resource
      }
    })
  }

  return(
    <>
      <Table sm="sm" responsive>
        <thead>
          <tr>
            <th>Kind</th>
            <th>Received On</th>
            <th>Notes</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            vaccines.map(vaccine=>(
              <tr>
                <td>{ vaccine.kind }</td>
                <td>{ moment(vaccine.received_on).format("MM/DD/YYYY") }</td>
                <td>{ vaccine.notes }</td>
                <td>
                  {
                    action === "edit" &&
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        showEditVaccineModal(vaccine);
                      }}>
                      Edit
                    </a>
                  }
                </td>
              </tr>
            ))
          }
          {
            action == 'edit' &&
            <tr>
              <td colSpan={4} className="text-center">
                <Button 
                  onClick={newVaccine}
                  variant="link">
                  Add Vaccine
                </Button>
              </td>
            </tr>
          }
        </tbody>
      </Table>
    </>
  )
}